import AppModule from './AppModule';

export { default as AppModule }
  from './AppModule';

export default AppModule;
